import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import Help from '@material-ui/icons/Help';
import { createElement, FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../../../theme';
import { SPACING_REGULAR, SPACING_UNIT } from '../../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../../styleUtility/flexibleLayout';
import { gridLayoutItem } from '../../../../styleUtility/gridLayout';

type Props = {
  messageId: string;
  anchor?: ReactNode;
};

const HelpExpressDelivery: FC<Props> = ({ messageId, anchor = null }) => {
  return (
    <HelpExpressDeliveryContainer variant="caption">
      <FormattedMessage id={messageId}>
        {(url: string) =>
          url.trim() !== '' && (
            <HelpAnchor href={url} target="_blank" rel="noopener noreferrer">
              <HelpIcon />
              {anchor}
            </HelpAnchor>
          )
        }
      </FormattedMessage>
    </HelpExpressDeliveryContainer>
  );
};

const HelpExpressDeliveryContainer = styled(Typography)`
  ${gridLayoutItem('help')}
  ${flexibleLayoutContainer({
    justifyContent: 'flex-start',
  })}
  margin-top: ${SPACING_REGULAR}px;
  margin-bottom: ${SPACING_UNIT}px;
`;

const HelpAnchor = styled('a')`
  ${gridLayoutItem('help')}
  display: inline-flex;
  align-items: center;
  color: ${theme.palette.secondary.main};
  text-decoration: none;
`;

const HelpIcon = styled(Help)`
  margin-right: 2px;
  font-size: 20px;
`;

export default HelpExpressDelivery;
